/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { request as __request } from "../../helpers/api/request";
import type { ProjectRenameRequest } from "../../models/projects/ProjectRenameRequest";
import type { ProjectRequest } from "../../models/projects/ProjectRequest";
import type { ProjectResponse } from "../../models/projects/ProjectResponse";
import type { ProjectResponsePageResponse } from "../../models/projects/ProjectResponsePageResponse";
import type { ProjectSaveRequest } from "../../models/projects/ProjectSaveRequest";
import type { ProjectSendRequest } from "../../models/projects/ProjectSendRequest";

export class ProjectsService {
  /**
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns ProjectResponsePageResponse Success
   * @throws ApiError
   */
  public static async get(pageSize?: number, pageNum?: number, sort?: string | null): Promise<ProjectResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/projects`,
      query: {
        PageSize: pageSize,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async add(requestBody?: ProjectRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/projects`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns ProjectResponse Success
   * @throws ApiError
   */
  public static async getById(id: number): Promise<ProjectResponse> {
    const result = await __request({
      method: "GET",
      path: `/projects/${id}`,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async delete(id: number): Promise<any> {
    const result = await __request({
      method: "DELETE",
      path: `/projects/${id}`,
    });
    return result.body;
  }

  /**
   * @param id
   * @param searchTerm
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns ProjectResponsePageResponse Success
   * @throws ApiError
   */
  public static async getByAccountId(
    id: number,
    searchTerm?: string | null,
    pageSize?: number,
    pageNum?: number,
    sort?: string | null
  ): Promise<ProjectResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/projects/account/${id}`,
      query: {
        SearchTerm: searchTerm,
        PageSize: pageSize,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param id
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns ProjectResponsePageResponse Success
   * @throws ApiError
   */
  public static async getByPartnerId(id: number, pageSize?: number, pageNum?: number, sort?: string | null): Promise<ProjectResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/projects/partner/${id}`,
      query: {
        PageSize: pageSize,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param partners
   * @param regions
   * @param cities
   * @param targetGroups
   * @param baseSystems
   * @param from
   * @param to
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns ProjectResponsePageResponse Success
   * @throws ApiError
   */
  public static async getFiltered(
    partners?: Array<number> | null,
    regions?: Array<number> | null,
    cities?: Array<number> | null,
    targetGroups?: Array<string> | null,
    baseSystems?: Array<number> | null,
    from?: string | null,
    to?: string | null,
    pageSize?: number,
    pageNum?: number,
    sort?: string | null
  ): Promise<ProjectResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/projects/filtered`,
      query: {
        Partners: partners,
        Regions: regions,
        Cities: cities,
        TargetGroups: targetGroups,
        BaseSystems: baseSystems,
        From: from,
        To: to,
        PageSize: pageSize,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async save(requestBody?: ProjectSaveRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/projects/save`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async sendToPartner(requestBody?: ProjectSendRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/projects/sendtopartner`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async sendToUser(id?: number): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/projects/sendtouser`,
      query: {
        id: id,
      },
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async rename(requestBody?: ProjectRenameRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/projects/rename`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async getPdf(id?: number): Promise<any> {
    const result = await __request({
      method: "GET",
      path: `/projects/pdf`,
      query: {
        id: id,
      },
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async getSystemProjectPdf(id?: number): Promise<any> {
    const result = await __request({
      method: "GET",
      path: `/projects/pdf/system`,
      query: {
        id: id,
      },
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async getSystemProjectExcel(id?: number): Promise<any> {
    const result = await __request({
      method: "GET",
      path: `/projects/excel/system`,
      query: {
        id: id,
      },
    });
    return result.body;
  }
}
